module.exports = __webpack_public_path__ + "static/flowers-f39229e3eb7a41b37fe93921003ced2c.png";